// extracted by mini-css-extract-plugin
export var button = "navigation-module--button--ckr-h";
export var buttonText = "navigation-module--buttonText--VsAp8";
export var iconNext = "navigation-module--iconNext--ayE6J";
export var iconPrev = "navigation-module--iconPrev--xekbI";
export var navigation = "navigation-module--navigation--Y7+yf";